import { useTranslation } from "react-i18next";
import { Drawer } from "melco-ui";
import { MachineStatusAddMachineGroupsList } from "./MachineStatusAddMachineGroupList";
import { MachineStatusAddAndSaveMachineGroupsList } from "./MachineStatusAddAndSaveMachineGroupsList";

type AddMachineDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
  addAndSave?: boolean | undefined;
};

export const MachineStatusAddMachineGroupDrawer: React.FC<
  AddMachineDrawerProps
> = ({ isDrawerOpen, setDrawerOpen, addAndSave }) => {
  const { t } = useTranslation();
  //const { closeDrawer, isDrawerOpen } = drawer;

  return (
    <Drawer
      title={t("reporting.machinegroups.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: 0 }}
    >
      {addAndSave ? (
        <MachineStatusAddAndSaveMachineGroupsList />
      ) : (
        <MachineStatusAddMachineGroupsList />
      )}
    </Drawer>
  );
};
